var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatChatting = function SvgChatChatting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.367 12.479 1.16.082c.508.037.762.055.952-.035a.8.8 0 0 0 .38-.38c.09-.19.072-.444.036-.953l-.083-1.16c-.013-.186-.02-.28-.021-.374-.003-.172-.005-.082.006-.253.005-.095.059-.542.165-1.434a5.333 5.333 0 0 0-9.706-3.638M9.2 10.4a3.6 3.6 0 1 0-7.155.57c.064.4.095.6.101.662.008.092.007.072.007.165 0 .061-.005.136-.016.285l-.066.924c-.024.343-.037.514.024.642a.54.54 0 0 0 .257.257c.128.06.3.048.642.024l.924-.066c.149-.01.223-.016.285-.016.093 0 .073-.001.165.007.062.006.262.037.661.101a3.591 3.591 0 0 0 3.373-1.295A3.585 3.585 0 0 0 9.2 10.4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatChatting);
export default ForwardRef;